import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    id: null,
    token: null,
    email: null,
    role: null,
    permissions: [],
    verificationType: null,
  },
  reducers: {
    userLogin: (state, action) => {
      state.id = action?.payload?.id;
      state.token = action?.payload?.token;
      state.role = action?.payload?.role;
      state.email = action?.payload?.email;
      state.permissions = action?.payload?.permissions || [];
    },
    setVerificationType: (state, action) => {
      state.verificationType = action?.payload;
    },
    setEmail: (state, action) => {
      state.email = action?.payload;
    },
    setRole: (state, action) => {
      state.role = action?.payload;
    },
    logOut: (state) => {
      state.id = null;
      state.token = null;
      state.email = null;
      state.role = null;
      state.permissions = [];
      state.verificationType = null;
    },
  },
});

export const { userLogin, setVerificationType, setEmail, setRole, logOut } = userSlice.actions;

export default userSlice.reducer;